module.exports = __webpack_public_path__ + "img/login_logo.74030373.png";